"use client";

import React from "react";
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
const expertiseData = [{
  title: "Ingénierie de certification RNCP/RS",
  description: "J'accompagne les organismes de formation et les organismes certificateurs dans la structuration, la sécurisation et le déploiement de leurs certifications auprès de France Compétences, en co-construisant avec les équipes et en vulgarisant les critères techniques."
}, {
  title: "Certification Qualiopi®",
  description: "Je prépare les organismes de formation aux audits Qualiopi® (initial, surveillance, renouvellement) et réalise des audits pour le compte d'organismes certificateurs. Les clients obtiennent leur certification sans non-conformité, grâce à un accompagnement pragmatique, structuré et pédagogique."
}, {
  title: "Évaluatrice Technique COFRAC",
  description: "Je suis évaluatrice technique pour le Comité Français d'Accréditation (Cofrac) dans le domaine de la formation professionnelle. Cette mission institutionnelle témoigne de la reconnaissance de mon expertise et me place au cœur des évolutions normatives et des pratiques d'excellence du secteur."
}, {
  title: "Cadre juridique de la formation",
  description: "Je conseille les acteurs de la formation sur la conformité réglementaire de leur activité : veille juridique, déclaration d'activité, sécurisation des conventions et des contrats de sous-traitance. L'objectif est de transformer les contraintes légales en pratiques sécurisées, claires et pérennes."
}];
export default function TechnicalExpertise() {
  const {
    ref: headerRef,
    isVisible: isHeaderVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  const {
    ref: gridRef,
    isVisible: isGridVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section data-section-id="169586" id="monpositionnement" className="relative bg-[#E8E4DF] text-foreground py-20 lg:py-24 overflow-hidden">
      <div className="container relative z-10 mx-auto px-4 md:px-6">
        {/* Header */}
        <div ref={headerRef} className={`max-w-3xl mx-auto text-center mb-14 lg:mb-20 transition-all duration-1000 ease-out ${isHeaderVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-10"}`}>
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-serif font-bold tracking-tight mb-6 text-[#62751D]">
            Une expertise reconnue dans des environnements exigeants
          </h2>
          <p className="text-lg md:text-xl text-slate-700 font-sans leading-relaxed">
            J'interviens dans des environnements à forts niveaux d'exigence, où la rigueur
            méthodologique, la maîtrise des cadres réglementaires et la capacité à sécuriser
            durablement les dispositifs sont indispensables.
          </p>
        </div>

        {/* Cards */}
        <div ref={gridRef} className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6 lg:gap-8">
          {expertiseData.map((item, i) => <div key={i} className={`transition-all duration-700 ease-out ${isGridVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-12"}`} style={{
          transitionDelay: `${i * 100}ms`
        }}>
              <Card className="relative h-full overflow-hidden bg-white border-l-4 border-l-[#62751D] border-t-0 border-r-0 border-b-0 rounded-lg shadow-md transition-all duration-500 hover:-translate-y-2 hover:shadow-xl group">
                <CardHeader className="pb-4">
                  <CardTitle className="text-xl md:text-2xl font-serif font-bold tracking-tight text-[#62751D] group-hover:text-[hsl(343,80%,35%)] transition-colors duration-300">
                    {item.title}
                  </CardTitle>
                </CardHeader>
                <CardContent>
                  <CardDescription className="text-base text-slate-700 font-sans leading-relaxed">
                    {item.description}
                  </CardDescription>
                </CardContent>
              </Card>
            </div>)}
        </div>
      </div>
    </section>;
}